export enum ResetPasswordStep {
  LOADING = 'LOADING',
  RESET_PASSWORD = 'RESET_PASSWORD',
  PASSWORD_UPDATED = 'PASSWORD_UPDATED',
  LINK_EXPIRED = 'LINK_EXPIRED',
  LINK_INVALID = 'LINK_INVALID',
}

export const LINK_ID_PARAM = 'link-id';
export const CODE_PARAM = 'code';

export const LINK_EXPIRED_ERROR_TEXT = 'Password reset link has expired';
